import Vue from 'vue'
import { Dialog, Button, Form, FormItem, Input, Carousel, CarouselItem, Row, Col, Card, Message, Scrollbar } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Dialog)
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(Scrollbar)
Vue.prototype.$message = Message



// WEBPACK FOOTER //
// ./src/plusin/elementUi.js